import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useAuth } from '../context/AuthContext';

const DeletedUsers = () => {
    const { getRequest } = useAuth();
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await getRequest('/get-all-deleted-users');
                console.log('Deleted users:', response.filter(item => item.user).map(({ user, ...rest }) => ({ ...user, ...rest })));
                setRowData(response.filter(item => item.user).map(({ user, ...rest }) => ({ ...user, ...rest })));
            } catch (error) {
                console.error('Error fetching all users:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, [getRequest]);

    const columns = [
        {
            field: 'displayName',
            headerName: 'Name',
            flex: 1.5,
        },
        {
            field: 'deletionReason',
            headerName: 'Reason',
            flex: 3,
        },
        {
            field: 'age',
            headerName: 'Age',
            flex: 1,
        },
        {
            field: 'fullLocation',
            headerName: 'Location',
            flex: 3,
        },
        {
            field: 'gender',
            headerName: 'Gender',
            flex: 1.5,
        },
    ];

    return (
        <Paper elevation={0} sx={{ padding: 2, height: 'calc(50% - 74px)', width: 'calc(50%)' }}>
            <Typography variant="h5" gutterBottom>
                Deleted Users
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
                View all deleted user information
            </Typography>
            <Box sx={{ height: '100%', width: '100%' }}>
                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <DataGrid
                        rows={rowData}
                        columns={columns}
                        getRowId={(row) => row?._id}
                        hideFooter
                        disableSelectionOnClick
                    />
                )}
            </Box>
        </Paper>
    );
};

export default DeletedUsers;
